import {isSystemMetric} from '../../../../util/metrics';
import {type RunsLinePlotConfig} from '../../types';

// Configs the columnar endpoint can't serve fall back to GraphQL.
export function checkColumnarBucketedSupport(
  config: RunsLinePlotConfig
): boolean {
  if (config.groupArea === 'stddev' || config.groupArea === 'stderr') {
    return false;
  }

  if (config.xAxis === '_absolute_runtime') {
    return false;
  }

  if (config.metrics?.some(isSystemMetric)) {
    return false;
  }

  if (config.xAxis && isSystemMetric(config.xAxis)) {
    return false;
  }

  return true;
}

export function checkBackendLinesSupport({
  config,
  context: {
    isInReport,
    panelId,
    usesBackendLineConstruction,
    usesBackendLineConstructionInReports,
  },
  usesBackendLineConstructionSmoothing,
  usesBackendLineConstructionTimeUnits,
}: {
  config: RunsLinePlotConfig;
  context: {
    isInReport?: boolean;
    panelId?: string;
    usesBackendLineConstruction: boolean;
    usesBackendLineConstructionInReports: boolean;
  };
  usesBackendLineConstructionSmoothing: boolean;
  usesBackendLineConstructionTimeUnits: boolean;
}) {
  const sharedContext = {
    panelId,
    usesBackendLineConstruction,
    usesBackendLineConstructionSmoothing,
  };

  if (isInReport && !usesBackendLineConstructionInReports) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'report panel',
    //   ...sharedContext,
    // });
    return false;
  }

  if (config.metrics && config.xAxis && config.metrics.includes(config.xAxis)) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'shared x and y axis metric',
    //   ...sharedContext,
    // });
    return false;
  }

  if (config.expressions) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'y-axis expressions',
    //   ...sharedContext,
    // });
    return false;
  }

  if (config.xExpression) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'x-axis expressions',
    //   ...sharedContext,
    // });
    return false;
  }

  if (
    config.smoothingWeight &&
    config.smoothingWeight > 0 &&
    !usesBackendLineConstructionSmoothing
  ) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'smoothing statsig flag disabled',
    //   ...sharedContext,
    // });
    return false;
  }

  if (
    (config.xAxis === '_absolute_runtime' || config.xAxis === '_runtime') &&
    !usesBackendLineConstructionTimeUnits
  ) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'backend line construction time units disabled',
    //   ...sharedContext,
    // });
    return false;
  }

  // log scales not yet supported
  if (config.xLogScale || config.yLogScale) {
    // recordRumAction('backend lines not supported', {
    //   reason: 'log scales',
    //   ...sharedContext,
    // });
    return false;
  }

  // cannot do backend lines for non-bucketing, should never be hit
  if (config.pointVisualizationMethod !== 'bucketing-gorilla') {
    // recordRumAction('backend lines not supported', {
    //   reason: 'non-bucketing visualization method',
    //   ...sharedContext,
    // });
    return false;
  }

  return true;
}
